
// const htmldiff = import('./html');

app.service("htmldiff", [function ($uibModal) {
    return htmldiff;
}]);